import axios from 'axios';

import {
  ADDRESS_PREQUAL_ENDPOINT,
  ADDRESS_SERVICE_URL,
  CHANNELS_JSON_CONFIG_URL,
  JSON_CONFIG_URL,
  REACT_APP_CT_CHANNEL_TOKEN,
  REACT_APP_CT_TOKEN_1,
  REACT_APP_CT_TOKEN_2,
  REACT_APP_ENDPOINT,
  REACT_APP_MSL_CT_ENDPOINT,
} from '@/lib/config';

import { sentryService } from '../services';

const responseInterceptor = async (err: any) => {
  if (err.response) {
    sentryService.captureException(err, { contexts: { response: err.response } });
    // if (err.response.status === 401 || err.response.status === 403) {
    //   console.log('here sentry')
    //   window.localStorage.setItem('redirectTo', window.location.pathname + window.location.search);
    //   getClient()?.logout({ returnTo: window.location.origin });
    // }
  }
  return Promise.reject(err);
};

// Request interceptor for CommerceTools API authentication
const ctRequestInterceptor = (config: any) => {
  // Switch tokens based on endpoint or custom logic
  // Example: use token 2 for specific endpoints, token 1 for others
  const endpoint = config.url || '';

  let token = REACT_APP_CT_TOKEN_1; // Default token

  // Switch to token 2 for specific endpoints (customize as needed)
  if (endpoint.includes('updateCart') || endpoint.includes('getCart')) {
    token = REACT_APP_CT_TOKEN_2; // Or use token 1/2 based on your requirement
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

export const ctAgent = axios.create({
  baseURL: REACT_APP_MSL_CT_ENDPOINT,
  headers: {
    'X-Channel-token': REACT_APP_CT_CHANNEL_TOKEN,
  },
});
// ctAgent.interceptors.request.use(ctRequestInterceptor);

export const addressAgent = axios.create({ baseURL: ADDRESS_SERVICE_URL });

export const prequalAgent = axios.create({ baseURL: ADDRESS_PREQUAL_ENDPOINT });

export const usersDetailsAgent = axios.create({
  baseURL: REACT_APP_ENDPOINT,
});

export const voiceAgent = axios.create({
  baseURL: REACT_APP_ENDPOINT,
});

export const serviceProviderAgent = axios.create({
  baseURL: REACT_APP_ENDPOINT,
});

export const technicianDetailsAgent = axios.create({ baseURL: REACT_APP_ENDPOINT });

export const channelJSONConfigAgent = axios.create({ baseURL: CHANNELS_JSON_CONFIG_URL });

export const channelsJSONConfigAgent = axios.create({ baseURL: CHANNELS_JSON_CONFIG_URL });

export const myAccountAgent = axios.create({ baseURL: REACT_APP_ENDPOINT });

export const staticJsonConfigAgent = axios.create({ baseURL: REACT_APP_ENDPOINT });

export const notifAgent = axios.create({ baseURL: REACT_APP_ENDPOINT });
export const orderAgent = axios.create({
  baseURL: REACT_APP_ENDPOINT,
});

export const agentJSONConfig = axios.create({ baseURL: JSON_CONFIG_URL });

usersDetailsAgent.interceptors.response.use(resp => resp, responseInterceptor);
voiceAgent.interceptors.response.use(resp => resp, responseInterceptor);
serviceProviderAgent.interceptors.response.use(resp => resp, responseInterceptor);

technicianDetailsAgent.interceptors.response.use(resp => resp, responseInterceptor);

prequalAgent.interceptors.response.use(resp => resp, responseInterceptor);

addressAgent.interceptors.response.use(resp => resp, responseInterceptor);

channelJSONConfigAgent.interceptors.response.use(resp => resp, responseInterceptor);

channelsJSONConfigAgent.interceptors.response.use(resp => resp, responseInterceptor);

myAccountAgent.interceptors.response.use(resp => resp, responseInterceptor);

notifAgent.interceptors.response.use(resp => resp, responseInterceptor);

orderAgent.interceptors.response.use(resp => resp, responseInterceptor);

ctAgent.interceptors.response.use(resp => resp, responseInterceptor);
